<div class="body">
  <div
    class="afiliado"
    *ngIf="
      rol == 'ROLE_ADMINISTRADOR' ||
      rol == 'ROLE_CONTABILIDAD' ||
      rol == 'ROLE_ENCARGADO_CONTABILIDAD'
    "
  >
    <div class="container" style="height: 100px"></div>
 
    <div
      class="container"
      id="tabla"
      style="background-color: white; padding-top: 50px; padding-bottom: 50px"
    >     
      <div class="row">
        <div class="col-lg-6"><h1>Carga descuentos</h1></div>

        <div class="col-lg-3"></div>
      </div>
      <hr />
      <br />

      <div class = "table-responsive">
        <tr>
        <td class="col-lg-1 col-xs-1" style="max-width: 12%">Adjuntar excel:</td>

        <td class="col-lg-1 col-xs-1">
          <input
            #csvInput
            hidden="true"
            type="file"
            enctype="multipart/form-data"
            onclick="this.value = null"
            (change)="csvInputChange($event)"
            accept=".csv"
          />

          <button mat-flat-button color="primary" (click)="csvInput.click()">
            Seleccione Archivo (CSV)
          </button>
        </td>
        <td class="col-lg-1 col-xs-1"  style="width: 52px;height: 40px;align-content: end;padding-bottom: 2em;padding-top: 1em;">
          <mat-form-field appearance="outline" class="mat-input" style="width: 230px;" >
            <mat-label> Archivo </mat-label>

            <input
              name="archivo"
              matInput
              style="width: 230px;"
              [value]="cargaMasiva?.archivo?.name"
              disabled="true"
            />
          </mat-form-field>
        </td>
        <td class="col-lg-1 col-xs-1"></td>
        <td class="col-lg-1 col-xs-1"></td>
        <td class="col-lg-1 col-xs-1"></td>
        <td class="col-lg-1 col-xs-1"></td>
          </tr>
        <tr>
        <td class="col-lg-1 col-xs-1"></td>
        <td class="col-lg-1 col-xs-1"></td>
        <td class="col-lg-2" *ngIf="botonActivo == true">
          <button
            class="btn btn-success"
            (click)="enviarPostulacionesSeleccionadas()"
          >
            Subir archivo
          </button>
        </td>
        <td class="col-lg-1 col-xs-1"></td>
        <td class="col-lg-1 col-xs-1"></td>
        <td class="col-lg-1 col-xs-1"></td>
        <td class="col-lg-1 col-xs-1"></td>
      </tr>
      </div>
      <br />
     
      <div class="row">
        <div class="col-lg-8"></div>
      </div>
    </div>

    <div class="container" style="height: 100px"></div>
  </div>
</div>
